// extracted by mini-css-extract-plugin
export default {"explanationbox":"explanation_explanationbox__8Fyt6","audiocontrol":"explanation_audiocontrol__9-y-t","explanationtable":"explanation_explanationtable__R75z9"};